import { render, staticRenderFns } from "./ElButton.vue?vue&type=template&id=30062602&scoped=true&"
import script from "./ElButton.vue?vue&type=script&lang=js&"
export * from "./ElButton.vue?vue&type=script&lang=js&"
import style0 from "./ElButton.vue?vue&type=style&index=0&id=30062602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30062602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
